var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"className":"container"}},[_c('line-chart',{attrs:{"data":_vm.chartData,"width":'1000px',"ytitle":'Số lượng',"xtitle":'Module được đồng bộ',"height":'400px',"loading":"Đang tải...","download":true,"curve":false,"thousands":","}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }